<template lang="html">
  <section>
    <div class="columns">
      <div class="column">
        <h1 class="title has-text-justified is-size-4">
          <span
            >{{ collection.attributes.name }}
            <b-tooltip :label="visibility" animated>
              <b-icon type="is-gray" :icon="typeIcon"></b-icon
            ></b-tooltip>
            <a v-if="collection.attributes.deletable" @click="isEditModalActive = true">
              <b-icon type="is-success" icon="pencil"></b-icon> </a
          ></span>
        </h1>
      </div>

      <div class="column is-narrow has-text-right">
        <small class="has-text-gray is-italic"
          >Last Update - {{ dateFromNow(collection.attributes.updated_at) }}</small
        >
      </div>
    </div>

    <div class="columns is-multiline">
      <div
        v-for="item in collection.attributes.collection_items"
        :key="item.data.id"
        class="column is-4"
      >
        <collection-item
          :item="item"
          :collections="collections"
          @collectionsUpdated="collectionsUpdated"
        />
      </div>
    </div>

    <!-- Modals -->
    <b-modal
      :active.sync="isEditModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <collection-edit
        :collection="collection"
        @collectionEdited="collectionEdited"
        @collectionRemoved="collectionRemoved"
      />
    </b-modal>
  </section>
</template>

<script>
import { dateMixin } from '@/mixins/dateMixin.js'
import CollectionEdit from './CollectionEdit.vue'
import CollectionItem from './CollectionItem'
export default {
  props: ['collection', 'collections'],
  mixins: [dateMixin],
  components: {
    CollectionEdit,
    CollectionItem
  },
  data () {
    return {
      isEditModalActive: false
    }
  },
  methods: {
    collectionEdited (values) {
      this.$emit('collectionEdited', values)
    },
    collectionsUpdated (values) {
      this.$emit('collectionsUpdated', values)
    },
    collectionRemoved (values) {
      this.$emit('collectionRemoved', values)
    }
  },
  computed: {
    visibility () {
      if (this.collection.attributes.hidden) return 'Visibility: Private'
      else return 'Visibility: Public'
    },
    typeIcon () {
      if (!this.collection.attributes.deletable) return 'heart-outline'
      else if (this.collection.attributes.hidden) return 'lock'
      else return 'earth'
    }
  }
}
</script>

<style lang="scss" scoped></style>
